<template>
	<page>
		<module enable-flex>
            <module-tab title="抵扣商品" @mounted="loadTabPage(1)" @activated="loadTabPage(1)" >
                <module-column enable-flex>
                    <m-search ref="search" @search="searchHandle">
                        <c-form>
                            <c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
                            <c-form-item type="input" label="商品货号" name="product_itemnumber"></c-form-item>
                        </c-form>
                    </m-search>

                    <m-operate>
                        <c-button color="sys" @click="addProduct">添加商品</c-button>
                    </m-operate>

                    <c-table ref="table">
                        <c-table-column
                                label="商品信息"
                                width="350"
                        >
                            <template v-slot="{data}">
                                <product-info  :image="data.product_img_url" :name="data.product_name"></product-info>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="商品货号"
                                name="product_itemnumber"
                                width="120"
                        ></c-table-column>

                        <c-table-column
                                label="规格名称"
                                width="200"
                                name="product_sku_spec"
                        ></c-table-column>

                        <c-table-column
                                label="商品售价"
                                name="sale_price"
                        ></c-table-column>

                        <c-table-column
                                label="商品库存"
                                name="stock_count"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                label="所需积分"
                                name="points"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                                width="140"
                        >
                            <template v-slot="row">
                                <c-table-button @click="setPoints(row)">设置积分</c-table-button>
                                <c-table-button @click="deleteProduct(row,1)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>
            </module-tab>

            <module-tab title="抵扣优惠券" @mounted="loadTabPage(2)" @activated="loadTabPage(2)">
                <module-column enable-flex>
                    <m-search ref="search" @search="searchHandle">
                        <c-form>
                            <c-form-item type="input" label="优惠券名称" name="coupon_name"></c-form-item>
                        </c-form>
                    </m-search>

                    <m-operate>
                        <c-button color="sys" @click="addCoupon">添加优惠券</c-button>
                    </m-operate>

                    <c-table ref="couponTable">
                        <c-table-column
                                label="优惠券名称"
                                name="coupon_name"
                                width="150"
                        >
                        </c-table-column>

                        <c-table-column
                                label="优惠力度"
                                name="detail"
                                width="120"
                        ></c-table-column>

                        <c-table-column
                                label="适用范围"
                                name="commodity_range"
                                width="70"
                        >
                            <template v-slot="{data}">
                                {{dict.couponRange[data.commodity_range]}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="剩余可领"
                                name="surplus"
                                width="70"
                        ></c-table-column>

                        <c-table-column
                                label="所需积分"
                                name="points"
                                width="80"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                                width="140"
                        >
                            <template v-slot="row">
                                <c-table-button @click="setPoints(row)">设置积分</c-table-button>
                                <c-table-button @click="deleteProduct(row,2)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>
            </module-tab>

		</module>
		
		<c-dialog ref="pointsDialog" title="设置积分" width="400" height="200" @resolve="setPointsHandle">
			<c-form ref="pointsForm">
				<c-form-item type="number" label="所需积分" name="points" :limit="[1, 99999]" required></c-form-item>
			</c-form>
		</c-dialog>
		
		<c-dialog ref="addDialog" title="添加可兑换商品" width="900" @resolve="addProductHandle">
			<m-operate>
				<c-button color="sys" @click="$refs.productSelector.open()">添加商品</c-button>
			</m-operate>
			
			<c-table ref="addTable" v-model="addList" height="400" :paging="false">
				<c-table-column
					label="商品信息"
					width="200"
				>
					<template v-slot="{data}">
						<product-info :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="商品货号"
					name="product_itemnumber"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="规格名称"
					width="160"
					name="product_sku_spec"
				></c-table-column>
				
				<c-table-column
					label="商品售价"
					name="sale_price"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="商品库存"
					name="stock_count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="所需积分"
				>
					<template v-slot="row">
						<c-input v-model="row.data.points" type="number"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="row">
						<c-table-button @click="row.remove()">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

        <c-dialog ref="addCouponDialog" title="添加可兑换优惠券" width="900" @resolve="addCouponHandle">
            <m-operate>
                <c-button color="sys" @click="$refs.couponSelector.open()">添加优惠券</c-button>
            </m-operate>

            <c-table v-model="couponList" height="400" :paging="false">
                <c-table-column
                        label="优惠券名称"
                        name="coupon_name"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="优惠力度"
                        name="detail"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="适用范围"
                        name="commodity_range"
                        width="70"
                >
                    <template v-slot="{data}">
                        {{dict.couponRange[data.commodity_range]}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="剩余可领"
                        name="surplus"
                        width="70"
                ></c-table-column>

                <c-table-column
                        label="所需积分"
                >
                    <template v-slot="row">
                        <c-input v-model="row.data.points" type="number"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="80"
                >
                    <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
		
		<product-selector ref="productSelector" sku multiple @resolve="productSelectHandle"></product-selector>
        <coupon-selector ref="couponSelector" multiple @resolve="couponSelectHandle"></coupon-selector>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import productSelector from '@/components/service/product_selector.vue'
    import couponSelector from '@/components/service/coupon_selector.vue'
    import {mapState} from "vuex";

	export default {
		name: 'm_points_product',
		
		components: {
			productInfo, productSelector, couponSelector
		},

        computed: {
            ...mapState(['dict'])
        },
		
		data() {
			return {
                exchangeType:'',
				addList: [],
                couponList:[],
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
		    loadTabPage(exchangeType){
		        this.exchangeType = exchangeType;
                this.$refs.search.search();
            },

			searchHandle(data) {
		        data.exchange_type = this.exchangeType;// 1:抵扣商品 2:抵扣优惠券
                if(this.exchangeType == 1){
                    this.$refs.table.load({
                        url: '/points_product/list',
                        data
                    });
                }else{
                    this.$refs.couponTable.load({
                        url: '/points_product/list',
                        data
                    });
                }

			},
			
			setPoints(item) {
				this._edit = item;
				this.$refs.pointsForm.set(item.data);
				this.$refs.pointsDialog.open();
			},
			
			setPointsHandle(stop) {
				stop();
				this.$refs.pointsForm.submit({
					url: '/points_product/edit/count',
					
					rule: {
						points: '请填写所需积分'
					},
					
					dataFormatter: data => {
						data.id = this._edit.data.id;
						return data;
					},
					
					success: data => {
						this._edit.update({
							points: data.points
						});
						this.$refs.pointsDialog.close();
						this.$message({
							text: '设置成功'
						});
					}
				})
			},
			
			deleteProduct(item,exchangeType) {
				this.$confirm({
					text: exchangeType == 1 ? '确定要删除此商品吗？' :'确定要删除此优惠券吗？',
					resolve: () => {
						this.request({
							url: '/points_product/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								if(exchangeType == 1){
                                    this.$refs.table.update();
                                }else{
                                    this.$refs.couponTable.update();
                                }
							}
						});
					}
				});
			},
			
			addProduct() {
				this.addList = [];
				this.$refs.productSelector.open();
			},
			
			productSelectHandle(list) {
				list = list.filter(item => {
					return !this.addList.find(row => {
						return row.product_sku == item.product_sku;
					});
				});
				this.addList = this.addList.concat(list);
				this.$refs.addDialog.open();
			},
			
			addProductHandle(stop) {
				stop();
				
				if (!this.addList.length) {
					this.$message({
						text: '请选择可兑换商品'
					});
					return;
				}
				
				if (this.addList.find(row => !row.points)) {
					this.$message({
						text: '请填写商品所需积分'
					});
					return;
				}
				
				this.request({
					url: '/points_product/add',
					data: {
                        exchange_type:1,
						list: Array.from(this.addList, (item) => {
							return {
								product_id: item.product_id,
								product_sku: item.product_sku,
								points: item.points
							}
						})
					},
					loading: true,
					success: () => {
						this.$refs.addDialog.close();
						this.$refs.table.update(1);
					}
				})
			},

            addCoupon() {
                this.couponList = [];
                this.$refs.couponSelector.open();
            },

            couponSelectHandle(list) {
                list = list.filter(item => {
                    return !this.couponList.find(row => {
                        return row.id == item.id;
                    });
                });
                this.couponList = this.couponList.concat(list);
                this.$refs.addCouponDialog.open();
            },

            addCouponHandle(stop) {
                stop();

                if (!this.couponList.length) {
                    this.$message({
                        text: '请选择可兑换优惠券'
                    });
                    return;
                }

                if (this.couponList.find(row => !row.points)) {
                    this.$message({
                        text: '请填写优惠券抵扣所需积分'
                    });
                    return;
                }

                this.request({
                    url: '/points_product/add',
                    data: {
                        exchange_type:2,
                        list: Array.from(this.couponList, (item) => {
                            return {
                                coupon_id: item.id,
                                points: item.points
                            }
                        })
                    },
                    loading: true,
                    success: () => {
                        this.$refs.addCouponDialog.close();
                        this.$refs.couponTable.update(1);
                    }
                })
            },

		}
	}
</script>